export const nuvemshop = {
  typeAnimationFeatures: [
    { title: "Atendimento com IA 24/7, com suporte WhatsApp" },
    { title: "Assistente de IA interna para sua loja" },
    { title: "Crie vídeos com IA em minutos" },
    // { title: "WhatsApp Business" },
  ],
  hero: {
    title: "Suíte de Inteligência Artificial para Nuvem Shop",
    subtitle:
      "Nossa suíte de IA traz o poder da inteligência artificial para sua loja Nuvem Shop, com agentes inteligentes de atendimento, automação e ferramentas de marketing avançadas.",
    cta: {
      primary: "Instalar Agora",
      secondary: "Veja como funciona",
    },
  },
  mainFeatures: {
    title: "Transforme sua Operação de E-commerce",
    subtitle: "Potencialize suas vendas com recursos avançados de IA",
  },
  features: {
    support24: {
      title: "Atendimento Automatizado 24/7",
      description:
        "Ofereça suporte instantâneo aos seus clientes com agentes de IA personalizados que funcionam no seu site e via WhatsApp, mesmo quando você não está disponível.",
    },
    automation: {
      title: "Automação Inteligente",
      description:
        "Reduza horas de trabalho manual com a assistente virtual Ária, que acessa dados, cria produtos e gerencia promoções diretamente do painel.",
    },
    marketing: {
      title: "Marketing Visual Poderoso",
      description:
        "Crie vídeos promocionais profissionais em minutos com nossa ferramenta de geração de vídeos por IA, sem necessidade de equipe especializada.",
    },
    integration: {
      title: "Integração Perfeita",
      description:
        "Todas as ferramentas de IA da Araria se integram nativamente à sua loja Nuvem Shop, sem necessidade de configurações técnicas complexas.",
    },
  },
  agents: {
    title: "Atendimento Inteligente para sua Loja",
    subtitle:
      "Transforme o atendimento ao cliente da sua loja com agentes de IA personalizados que conhecem seus produtos, políticas e respondem dúvidas 24 horas por dia, 7 dias por semana.",
  },
  agent: {
    features: {
      knowledge: {
        title: "Base de Conhecimento Personalizada",
        description:
          "Alimente seu agente com informações específicas sobre seus produtos, políticas de troca, prazos de entrega e FAQs",
      },
      channels: {
        title: "Múltiplos Canais de Atendimento",
        description: "Disponibilize o mesmo agente no seu site e via WhatsApp",
      },
      personality: {
        title: "Personalidade Ajustável",
        description:
          "Configure o tom de comunicação do seu agente para refletir a identidade da sua marca",
      },
      analytics: {
        title: "Análise de Performance",
        description:
          "Acompanhe métricas de atendimento e satisfação dos clientes",
      },
    },
  },
  whatsapp: {
    title: "Atendimento via WhatsApp com Inteligência Artificial",
    subtitle:
      "Leve seu atendimento para onde seus clientes estão. Os agentes da Araria funcionam perfeitamente no WhatsApp, permitindo que você automatize tanto campanhas promocionais quanto suporte ao cliente.",
    features: {
      instant: {
        title: "Atendimento Instantâneo",
        description:
          "Respostas imediatas 24/7 no canal preferido dos consumidores",
      },
      recovery: {
        title: "Recuperação de Carrinhos",
        description: "Lembre clientes sobre produtos abandonados no carrinho",
      },
      campaigns: {
        title: "Campanhas Promocionais",
        description: "Envie ofertas personalizadas para clientes segmentados",
      },
      tracking: {
        title: "Acompanhamento de Pedidos",
        description:
          "Atualize clientes sobre status de entrega automaticamente",
      },
    },
  },
  aria: {
    title: "Conheça Ária: Sua Assistente Virtual Especializada em E-commerce",
    subtitle:
      "Ária não é um simples chatbot. É uma assistente inteligente desenvolvida especificamente para gestão de e-commerce, integrada ao ambiente administrativo da sua loja Nuvem Shop.",
    features: {
      products: {
        title: "Gestão de Produtos",
        description: "Crie e atualize produtos com assistência inteligente",
      },
      promotions: {
        title: "Gestão de Promoções",
        description: "Gerencie promoções e cupons de desconto facilmente",
      },
      tools: {
        title: "Ferramentas Avançadas",
        description: "Acesse ferramentas de otimização e análise da loja",
      },
    },
  },
  videoCreator: {
    title: "Transforme Fotos em Vídeos Profissionais em Minutos",
    subtitle:
      "Nossa ferramenta de criação de vídeos com IA transforma as fotos do seu catálogo em conteúdo publicitário profissional para suas redes sociais e campanhas de marketing.",
    features: {
      creation: {
        title: "Criação Automática",
        description: "Transforme fotos em vídeos profissionais automaticamente",
      },
      customization: {
        title: "Personalização Total",
        description: "Adicione sua marca, música e elementos visuais",
      },
      sharing: {
        title: "Compartilhamento Fácil",
        description: "Publique diretamente nas redes sociais",
      },
    },
  },
  cta: {
    title: "Comece a Transformar seu E-commerce Hoje",
    subtitle:
      "Instale o Hub de IA da Araria e leve sua loja Nuvem Shop para o próximo nível",
    button: "Instalar Gratuitamente",
  },
};
